import React, { useEffect } from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { useObjectSidebar } from '../useObjectSidebar';
import { useWidthResizeObserver } from '../useWidthResizeObserver';

const panelPushStyles = xcss({
	display: 'block',
	flex: '1',
});

export const ObjectSidebarPushPlaceholder = () => {
	const [, { setPanelWidth }] = useObjectSidebar();
	const [containerRef, width] = useWidthResizeObserver();

	useEffect(() => {
		setPanelWidth(width);
	}, [width, setPanelWidth]);

	return <Box ref={containerRef} xcss={panelPushStyles} />;
};
